import { Controller } from "@hotwired/stimulus"
import { baseKit } from "../shared/browserKit"
import { doit, tapChain, recall } from "../shared/functions"

// Connects to :: <section x-ignore v-pre data-controller="petite-vue">
// Script :: <script data-petite-vue-target="setup" >
export default baseKit(({ dispatchElement })=>{
  const loadOptions = {
    apiKey: "AIzaSyCRLqccYVyDvpElEqaJNHgg4bsOzwBRUIM",
    version: "quarterly",
    libraries: ["maps", "geocoding", "marker", "places", "elevation", "geometry"]
  }

  return class extends Controller {

    // static targets = [
    //   "view",
    // ]

    connect() {
      const controller = this
      const rootElement = this.element
      
      const koreaBounds = {
        north: 39.15157738781489,
        south: 32.753690214482596,
        east: 132.0,
        west: 124.5
      }

      const mapOptions = {
        // mapId: Platform > 지도관리 > 생성
        mapId: 'bc0eaf137b35c23e800ea0ee',
        restriction: {
          latLngBounds: koreaBounds,
          strictBounds: false // true로 바꾸면 더 엄격하게 제한
        },
        center: { lat: 37.51591975564616, lng: 127.05801628482645 },
        zoom: 9,
        streetViewControl: false,
        mapTypeControl: false,
        // 구글 기본 POI 정보창 비활성화
        clickableIcons: false,
        // 기본 UI 요소들 비활성화 (선택사항)
        disableDefaultUI: false,
        // 특정 POI 카테고리 숨기기
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }]
          }
        ]
      }

      const mapContainer = document.createElement("div")
      mapContainer.id = "map2"
      mapContainer.style.width = "100%"
      mapContainer.style.height = "400px"
      rootElement.appendChild(mapContainer)
      
      import("@googlemaps/js-api-loader").then((jsApi)=>{
        doit(new jsApi.Loader(loadOptions)).load()
        .then((google) => {
          const map = new google.maps.Map(mapContainer, mapOptions)
          const elevation = new google.maps.ElevationService()
          const geocoder = new google.maps.Geocoder()
          
          // 기본 InfoWindow 완전히 차단
          map.addListener('click', (event) => {
            // 기본 정보창이 열리는 것을 방지
            if (event.placeId) {
              event.stop();
            }
          });
          
          return tapChain({ google, map, elevation, geocoder})
        })
        .then(
          // 하나의 마커와 마커 윈도우 (검색/클릭 공용)
          recall(async (props)=>{
            const { google } = props
            
            // 단일 마커 (검색과 클릭 시 공용으로 사용)
            const selectedMarker = new google.maps.marker.AdvancedMarkerElement({
              position: mapOptions.center,
              map: null,
              title: "",
            })

            const selectedMarkerWindow = new google.maps.InfoWindow({});
            
            props.selectedMarker = selectedMarker
            props.selectedMarkerWindow = selectedMarkerWindow
          }
        ))
        .then(
          // 검색
          recall(async ({ google, map, selectedMarker, selectedMarkerWindow })=>{
            await google.maps.importLibrary("places");
            const gmpPlaceSearchElement = new google.maps.places.PlaceAutocompleteElement({
              includedRegionCodes: ['kr'] // 대한민국만 검색
            });
            rootElement.appendChild(gmpPlaceSearchElement);

            // 검색 이벤트
            gmpPlaceSearchElement.addEventListener('gmp-select', async (event) => {
              const { placePrediction } = event
              const place = placePrediction.toPlace();
              await place.fetchFields({ fields: ['displayName', 'formattedAddress', 'location', 'types'] });
              
              // 동일한 마커 재사용
              selectedMarker.position = place.location;
              selectedMarker.title = place.displayName || place.formattedAddress || "";
              selectedMarker.map = map; // 지도에 표시
              
              // 클릭 시와 동일한 정보창 내용
              selectedMarkerWindow.setContent(`
                <div>
                  <h3>${place.displayName || place.formattedAddress || ""}</h3>
                  <p>${place.formattedAddress || ''}</p>
                </div>
              `);
              
              selectedMarkerWindow.open({
                map,
                anchor: selectedMarker,
                shouldFocus: false,
              })
              
              map.setCenter(place.location);
              map.setZoom(14);
              
              const marker_location = {
                display_name: place.displayName,
                formatted_address: place.formattedAddress,
                place_types: place.types,
                lat: place.location.lat(),
                lng: place.location.lng(),
                zoom: map.getZoom(),
              }

              // 외부로 검색 이벤트 전달
              dispatchElement(rootElement, 'map:marked' , {
                markerType: "search",
                ...marker_location,
              })
            });
          }
        ))
        .then(
          // 클릭시 시설 검색 및 마커 이동
          recall(async ({ google, map, selectedMarker, selectedMarkerWindow, geocoder })=>{
            const placesService = new google.maps.places.PlacesService(map)
            
            map.addListener("click", async (event) => {
              const zoom = map.getZoom()
              const lat = event.latLng.lat()
              const lng = event.latLng.lng()
              
              // 기본 정보창 방지
              if (event.placeId) {
                event.stop();
              }
              
              console.log("Zoom:", zoom, "Lat:", lat, "Lng:", lng)
              
              geocoder.geocode({ location: event.latLng }, (results, status) => {
                if (status === 'OK' && results[0]) {
                  const place = results[0]

                  // 행정구역 displayName 추출 함수
                  function extractAdministrativeName(addressComponents) {
                    let province = ''
                    let city = ''
                    let district = ''
                    let sublocality = ''
                    let village = ''
                    addressComponents.forEach(component => {
                      const types = component.types
                      if (types.includes('administrative_area_level_1')) {
                        province = component.long_name
                      } else if (types.includes('administrative_area_level_2')) {
                        city = component.long_name
                      } else if (types.includes('administrative_area_level_3')) {
                        district = component.long_name
                      } else if (types.includes('sublocality_level_1') || types.includes('administrative_area_level_4')) {
                        sublocality = component.long_name
                      } else if (types.includes('sublocality_level_2') || types.includes('administrative_area_level_5')) {
                        village = component.long_name
                      }
                    })
                    // display_name: "xx구 xx동" 또는 "xx시 xx동" 등
                    if (district && sublocality) return `${district} ${sublocality}`
                    if (city && sublocality) return `${city} ${sublocality}`
                    if (sublocality) return sublocality
                    if (district) return district
                    if (city) return city
                    if (village) return village
                    return ''
                  }

                  // 행정구역 전체 주소 생성 함수
                  function administrativeAddress(addressComponents) {
                    let province = ''
                    let city = ''
                    let district = ''
                    let sublocality = ''
                    let village = ''
                    addressComponents.forEach(component => {
                      const types = component.types
                      if (types.includes('administrative_area_level_1')) {
                        province = component.long_name
                      } else if (types.includes('administrative_area_level_2')) {
                        city = component.long_name
                      } else if (types.includes('administrative_area_level_3')) {
                        district = component.long_name
                      } else if (types.includes('sublocality_level_1') || types.includes('administrative_area_level_4')) {
                        sublocality = component.long_name
                      } else if (types.includes('sublocality_level_2') || types.includes('administrative_area_level_5')) {
                        village = component.long_name
                      }
                    })
                    const parts = []
                    if (province) parts.push(province)
                    if (city) parts.push(city)
                    if (district) parts.push(district)
                    if (sublocality) parts.push(sublocality)
                    if (village) parts.push(village)
                    return parts.join(' ')
                  }

                  let displayName, formattedAddress

                  if (zoom < 14) {
                    // 14 미만: 행정구역까지만
                    formattedAddress = administrativeAddress(place.address_components)
                    displayName = extractAdministrativeName(place.address_components) || formattedAddress
                  } else {
                    // 14 이상: displayName은 동/리까지만, formattedAddress는 번지수까지 전체 주소
                    displayName = extractAdministrativeName(place.address_components) || place.formatted_address
                    formattedAddress = place.formatted_address
                  }

                  selectedMarker.position = event.latLng;
                  selectedMarker.title = displayName;
                  selectedMarker.map = map;

                  selectedMarkerWindow.setContent(`
                    <div>
                      <h3>${displayName}</h3>
                      <p>${formattedAddress}</p>
                    </div>
                  `);

                  google.maps.event.clearListeners(selectedMarker, 'click');
                  selectedMarker.addListener("click", () => {
                    selectedMarkerWindow.open({
                      map,
                      anchor: selectedMarker,
                      shouldFocus: false,
                    })
                  })

                  const marker_location = {
                    display_name: displayName,
                    formatted_address: formattedAddress,
                    place_types: place.types || [],
                    lat: lat,
                    lng: lng,
                    zoom: zoom,
                  }

                  dispatchElement(rootElement, "map:marked", {
                    markerType: zoom < 14 ? "administrative" : "address",
                    ...marker_location,
                  })

                  selectedMarkerWindow.open({
                    map,
                    anchor: selectedMarker,
                    shouldFocus: false,
                  })
                } else {
                  // 주소를 찾을 수 없는 경우 기존 함수 사용
                  handleEmptyLocation(event.latLng, lat, lng, zoom)
                }
              })

              // 공통 함수: 빈 공간 처리
              function handleEmptyLocation(latLng, lat, lng, zoom) {
                selectedMarker.position = latLng;
                selectedMarker.title = "선택된 위치";
                selectedMarker.map = map;
                
                selectedMarkerWindow.setContent(`
                  <div>
                    <h3>선택된 위치</h3>
                    <p>주소가 없는 위치</p>
                    <p>위도: ${lat.toFixed(6)}</p>
                    <p>경도: ${lng.toFixed(6)}</p>
                  </div>
                `);
                
                // 일반 클릭 이벤트 전달
                dispatchElement(rootElement, "map:marked", {
                  markerType: "empty",
                  display_name: "주소가 없는 위치",
                  formatted_address: `위도: ${lat.toFixed(6)}, 경도: ${lng.toFixed(6)}`,
                  place_types: [],
                  lat: lat,
                  lng: lng,
                  zoom: zoom,
                })
                
                // 정보창 자동으로 열기
                selectedMarkerWindow.open({
                  map,
                  anchor: selectedMarker,
                  shouldFocus: false,
                })
              }
            })
          }
        ))
      })
    }
  }
})
